import UtilString from '../../../../utils/UtilString';
import MyText from '../../../../components/myText/MyText';
import MyFlex from '../../../../components/myFlex/MyFlex';
import MyTextSecondary from '../../../../components/myText/MyTextSecondary';
import './ActivityRightCardRow.scss';

const ActivityRightCardRow = ({
  data,
  bold,
  icon,
  title,
  style,
  noSpace,
  secondary,
  secondStyle,
  className = UtilString.EMPTY_STRING,
  secondClassName = UtilString.EMPTY_STRING,
}) => {
  return (
    <MyFlex align="top" justify={noSpace ? 'flex-start' : 'space-between'}>
      {title ? (
        <MyTextSecondary
          bold={bold}
          style={style}
          color={secondary ? undefined : 'var(--ant-color-text)'}
          className={`activity_right_card_row_title ${className}`}
        >
          {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
          {title}:
        </MyTextSecondary>
      ) : null}
      <MyText
        style={secondStyle}
        className={`activity_right_card_row_value ${secondClassName}`}
      >
        {data ? data : '-'}
      </MyText>
    </MyFlex>
  );
};

export default ActivityRightCardRow;
